import React from "react";
import { Box, Typography, Grid, Paper, Avatar, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderRadius: "15px",
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    marginBottom: theme.spacing(2),
        width:"350px",
    height:"200px"
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    marginRight: theme.spacing(2),
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardContent: {
    flex: 1,
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: "1.2rem",
  },
  cardCount: {
    fontWeight: 500,
    fontSize: "1.5rem",
  },
}));
const InfoCards = ({ icon, title, count, color }) => {
  const classes = useStyles();
  return (
    <Box className={classes.cardContainer} style={{ backgroundColor: color }}>
      <Avatar className={classes.avatar}>{icon}</Avatar>
      <Box className={classes.cardContent}>
        <Typography variant="h6" className={classes.cardTitle}>
          {title}:  {count}
        </Typography>
        {/* <Typography variant="h4" className={classes.cardCount}>
          {count}
        </Typography> */}
      </Box>
    </Box>
  );
};

export default InfoCards;
